<template lang="pug">
.services
  .services__copy(v-html="details.Description")    
  .services__content(v-if="details.Services")
    .services__content-header Branch Services
    .services__content-html(v-html="details.Services")

</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["details"]),
  },
};




</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.services {
  * {
    font-family: 'News Gothic', Sans-Serif, sans-serif;
  }

  margin-top: 4rem;
  position: relative;
  z-index: 0;
  padding: 3rem 0;
  display: flex;
  gap: 1rem;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100vw;
    left: 50%;
    transform: translateX(-50%);
    background: #EAF2F6;
    z-index: -1;
  }

  @include mqdn(lg) {
    flex-direction: column;
  }

  &__copy {
    flex: 1;
  }

  &__header {
    font-weight: 700;
    font-size: 2.2rem;
    margin: 0;
  }

  &__content {
    flex: 1;

    &-header {
      text-transform: uppercase;
      position: relative;
      font-size: 1rem;

      &:after {
        content: '';
        position: absolute;
        bottom: -.25rem;
        height: 2px;
        width: 70px;
        left: 0;
        background: $red;
      }
    }

    &-html {
      margin-top: 2rem;

      ul {
        -webkit-column-count: 2 !important;
        /* Chrome/Opera, Safari */
        -moz-column-count: 2 !important;
        /* Mozilla Firefox */
        column-count: 2 !important;
      }
    }
  }
}

// .services ul{
//  -webkit-column-count: 2!important;  /* Chrome/Opera, Safari */
//  -moz-column-count: 2 !important; /* Mozilla Firefox */
//  column-count: 2 !important;
// }
</style>
